import moment from 'moment'

const DefaultStoreStateOfList = {
  filtering: {
    status: null,
    dateRange: null,
    keyword: null,
    advance: {}
  },
  list: [], // all data
  tableData: [], // displayed data
  searchedObjs: [], // filtered data
  lastFetchedAt: null,
  isFetched: false,
  isFetching: false,
  isReloaded: false,
  loadingMap: {},
  isLoading: false,
}

const DefaultStoreStateOfEditor = {
  loadingMap: {},
  isLoading: false,
}

export function genDefaultStoreStateOfList () {
  return JSON.parse(JSON.stringify(DefaultStoreStateOfList))
}

export function genDefaultStoreStateOfEditor () {
  return JSON.parse(JSON.stringify(DefaultStoreStateOfEditor))
}

export function mutations_setLoading (state, payload) {
  if (payload.isLoading) {
    state.loadingMap[payload.key] = payload.isLoading
  } else {
    delete state.loadingMap[payload.key]
  }
  let isLoadingNow = Object.keys(state.loadingMap).length > 0
  if (isLoadingNow !== state.isLoading) state.isLoading = isLoadingNow
}

export function genDefaultModuleOfList(dataName, service) {
  return {
    state: () => genDefaultStoreStateOfList(),
    mutations: {
      setData(state, payload) {
        state.list = payload
      },
      setLoading: mutations_setLoading
    },
    actions: {
      fetchData({state,commit, dispatch}) {
        return new Promise(async (resolve, reject) => {
          if (state.isFetching) {
            var timer = setInterval(() => {
              if (state.isFetching) return
              clearInterval(timer)
              if (state.isFetched) {
                resolve(state.list)
              } else {
                reject(new Error('無法取得資料，請嘗試重新整理'))
              }
            }, 500)
            return
          }
          state.isFetching = true
          var query = null
          if (state.lastFetchedAt) {
            query = { from: state.lastFetchedAt }
          }
          try {
            let dataList = await dispatch('getList', query)
            if (!state.list || !state.list.length) {
              state.list = dataList
            } else {
              for (let data of dataList) {
                let idx = state.list.findIndex(o => o.ID === data.ID)
                if (idx >= 0) {
                  state.list[idx] = data
                } else {
                  state.list.splice(0, 0, data)
                }
              }
            }
  
            state.isFetched = true
            state.fecthedAt = true
            state.isReloaded = false
            state.isFetching = false
            state.lastFetchedAt = moment().format('YYYY-MM-DD HH:mm:ssZ')
            resolve()
          } catch(err) {
            state.isFetching = false
            reject(err)
          }
              
        })
      },
      async getList({commit}, query) {
        var dataList = []
        let vm = {setLoading:()=>{}}
        commit('setLoading', {key: `Service<${dataName}>.getList`, isLoading: true})
        try {
          let res = await service.getAll(vm, query)
          dataList = res.data.data
        } catch(err) {
          throw err
        } finally {
          commit('setLoading', {key: `Service<${dataName}>.getList`, isLoading: false})
        }
        return dataList
      },
      async delete({state, commit}, id) {
        let vm = {setLoading:()=>{}}
        commit('setLoading', {key: `Service<${dataName}>.delete`, isLoading: true})
        try {
          let res = await service.delete(vm, id)
          let idx = state.list.findIndex(o => o.ID === id)
          // if (idx >= 0) state.list.splice(idx, 1)
          if (idx >= 0) state.list[idx].DeletedAt = moment()
        } catch(err) {
          throw err
        } finally {
          commit('setLoading', {key: `Service<${dataName}>.delete`, isLoading: false})
        }
      }
    },
    getters: {
      dataList(state) {
        return state.list.filter(o => !o.DeletedAt)
      }
    }
  }
}

export function genDefaultModuleOfEditor(dataName, service) {
  return {
    state: () => genDefaultStoreStateOfEditor(),
    mutations: {
      setLoading: mutations_setLoading
    },
    actions: {
      async create({state, commit}, obj) {
        let vm = {setLoading:()=>{}}
        commit('setLoading', {key: `Service<${dataName}>.create`, isLoading: true})
        try {
          let res = await service.add(vm, obj)
          // let newObj = res.data.data
          // if(newObj)state.list.push(newObj)
        } catch(err) {
          throw err
        } finally {
          commit('setLoading', {key: `Service<${dataName}>.create`, isLoading: false})
        }
      },
      async update({state, commit}, payload) {
        let vm = {setLoading:()=>{}}
        commit('setLoading', {key: `Service<${dataName}>.update`, isLoading: true})
        try {
          let res = await service.edit(vm, payload.id, payload.payload)
          // let newObj = res.data.data
          // if (newObj) {
          //   let idx = state.list.findIndex(o => o.ID === obj.ID)
          //   Vue.set(state.list, idx, newObj)
          // }
        } catch(err) {
          throw err
        } finally {
          commit('setLoading', {key: `Service<${dataName}>.update`, isLoading: false})
        }
      }
    },
    getters: {}
  }
}

// launch / login...
export function genDefaultModuleOfView() {
  return {
    state: () => {
      return {
        loadingMap: {},
        isLoading: false,
      }
    },
    mutations: {
      setLoading: mutations_setLoading
    },
  }
}